import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";
import { PackageManagementImpl } from "../data/PackageManagementImpl";
import { IPackageManagementRepository } from "../domain/repositories/IPackageManagementRepository";
import { PackageManagementUseCase } from "../domain/useCases/PackageManagementUseCase";
import { PackageManagementViewModel } from "../presentation/viewModel/PackageManagementViewModel";

export class PackageManagementInjection extends InjectionModule {
  private static readonly packageManagementRepositoryToken = Symbol(
    "IPackageManagementRepository",
  );
  private static readonly packageManagementUseCaseToken = Symbol(
    "PackageManagementUseCase",
  );
  private static readonly packageManagementViewModelToken = Symbol(
    "PackageManagementViewModel",
  );

  protected static override bindings: InjectionBinding[] = [
    {
      token: this.packageManagementRepositoryToken,
      useClass: PackageManagementImpl,
      scope: "otherRepo",
    },
    {
      token: this.packageManagementUseCaseToken,
      useClass: PackageManagementUseCase,
      scope: "otherRepo",
    },
    {
      token: this.packageManagementViewModelToken,
      useClass: PackageManagementViewModel,
      scope: "viewModel",
    },
  ];

  static getRepo(): IPackageManagementRepository {
    return this.resolve(this.packageManagementRepositoryToken);
  }

  static getUseCase(): PackageManagementUseCase {
    return this.resolve(this.packageManagementUseCaseToken);
  }
}
